import React from 'react';
import { Controller } from 'react-hook-form';
import Input from './Input';

const TextInput = ({
  name,
  control,
  displayName,
  required,
  placeholder,
  errors,
  validate,
  innerRef,
  disabled,
  className,
  onFocus,
  onSelect,
  area,
  prefix,
  onChange: onValueChange
}) => {

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: required ? `${displayName} is required` : null,
        validate: validate
      }}
      render={({ field: { ref, onChange, ...field } }) => (
        <Input
          {...field}
          type={area ? "textarea" : null}
          placeholder={placeholder ?? displayName}
          invalid={!!errors}
          disabled={disabled}
          innerRef={innerRef}
          onFocus={onFocus}
          onSelect={onSelect}
          className={className}
          prefix={prefix}
          onChange={e => {
            onChange(e)
            if (onValueChange) onValueChange(e.target.value)
          }}
        />
      )}
    />
  );
};

export default TextInput;
